

export default class ReminderTranslationResponse  {
	LangCode?: string = '';
	Title?: string = '';
	Text?: string = '';
	constructor(obj?: Partial<ReminderTranslationResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
